"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FileUtil = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _GeoJSON = _interopRequireDefault(require("ol/format/GeoJSON"));

var _Vector = _interopRequireDefault(require("ol/layer/Vector"));

var _Vector2 = _interopRequireDefault(require("ol/source/Vector"));

var _shpjs = _interopRequireDefault(require("shpjs"));

/**
 * Helper class for adding layers from various file formats.
 *
 * @class
 */
var FileUtil = /*#__PURE__*/function () {
  function FileUtil() {
    (0, _classCallCheck2["default"])(this, FileUtil);
  }

  (0, _createClass2["default"])(FileUtil, null, [{
    key: "addGeojsonLayerFromFile",
    value:
    /**
     * Adds a new vector layer from a geojson file.
     * @param {File} file the file to read the geojson from
     * @param {ol.Map} map the map to add the layer to
     */
    function addGeojsonLayerFromFile(file, map) {
      var reader = new FileReader();
      reader.readAsText(file);
      reader.addEventListener('loadend', function () {
        var content = reader.result;
        FileUtil.addGeojsonLayer(content, map);
      });
    }
    /**
     * Adds a new vector layer from a shape file (zip).
     * @param {File} file the file to read the geojson from
     * @param {ol.Map} map the map to add the layer to
     */

  }, {
    key: "addShpLayerFromFile",
    value: function addShpLayerFromFile(file, map) {
      var reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.addEventListener('loadend', function () {
        var blob = reader.result;
        (0, _shpjs["default"])(blob).then(function (json) {
          FileUtil.addGeojsonLayer(json, map);
        });
      });
    }
    /**
     * Adds a new vector layer from a geojson string.
     * @param {string} json the geojson string
     * @param {ol.Map} map the map to add the layer to
     */

  }, {
    key: "addGeojsonLayer",
    value: function addGeojsonLayer(json, map) {
      var format = new _GeoJSON["default"]();
      var features = format.readFeatures(json);
      var layer = new _Vector["default"]({
        source: new _Vector2["default"]({
          features: features
        })
      });
      map.addLayer(layer);
    }
  }]);
  return FileUtil;
}();

exports.FileUtil = FileUtil;
var _default = FileUtil;
exports["default"] = _default;